import axios from 'axios';
import { resolveAuthHeaderValue } from '@/utils/authToken';
import { apiUrl } from '@/utils/appConfig';

const client = axios.create({ baseURL: apiUrl() });

client.interceptors.request.use(config => {
  const authHeaderValue = resolveAuthHeaderValue();
  if (!authHeaderValue) return config;
  const nextConfig = { ...config };
  if (!nextConfig.headers) nextConfig.headers = {};
  nextConfig.headers.Authorization = authHeaderValue;
  return nextConfig;
});

export async function getSchedule(streamId) {
  try {
    const { data } = await client.get(`/api/streams/${encodeURIComponent(streamId)}/schedule`);
    return data;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

export async function upsertSchedule(streamId, payload) {
  const { data } = await client.put(`/api/streams/${encodeURIComponent(streamId)}/schedule`, payload);
  return data;
}

export async function deleteSchedule(streamId) {
  await client.delete(`/api/streams/${encodeURIComponent(streamId)}/schedule`);
}

export async function setScheduleEnabled(streamId, enabled) {
  const { data } = await client.patch(
    `/api/streams/${encodeURIComponent(streamId)}/schedule/enabled`,
    { enabled },
  );
  return data;
}

export async function runNow(streamId, settings = null) {
  // When `settings` is provided, the run uses these currently-selected (unsaved)
  // cmaker.* values as a one-off config override instead of the saved stream settings.
  const body = settings ? { settings } : {};
  const { data } = await client.post(`/api/streams/${encodeURIComponent(streamId)}/schedule/run-now`, body);
  return data;
}

export async function listFires(streamId, limit = 20) {
  const { data } = await client.get(`/api/streams/${encodeURIComponent(streamId)}/schedule/fires`, {
    params: { limit },
  });
  return Array.isArray(data) ? data : [];
}

export async function getStreamSpend(streamId, { from, to } = {}) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const { data } = await client.get(`/api/streams/${encodeURIComponent(streamId)}/spend`, { params });
  return data;
}
